import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import CompleteProfile from "./pages/CompleteProfile";
import ForgotPassword from "./pages/ForgotPassword";
import Logout from "./pages/Logout";
import DefaultPage from "./pages/DefaultPage";
import ProtectedUserRoute from "./pages/ProtectedUserRoute";
import AccountHome from "./pages/account/AccountHome";
import { useAppContext } from "./context/appContext";
import { Toast } from "primereact/toast";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import TokenService from "./utils/TokenService";
import { Mixpanel } from "./utils/Mixpanel";

const AppWrapper = (props) => {
    let location = useLocation();
    const [currentVersion, setCurrentVersion] = useState(null);
    const checkCountRef = useRef(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const toast = useRef();
    const { showAlert, alertType, alertDetail, clearAlert } = useAppContext();
    useEffect(() => {
        if (showAlert) {
            if (alertType === "error") {
                toast.current.show({ severity: alertType, detail: alertDetail, life: 5000 });
            } else {
                toast.current.show({ severity: alertType, detail: alertDetail, life: 2000 });
            }
            clearAlert();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAlert]);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch(`/id-ui-version.json?t=${new Date().getTime()}`);
                const data = await response.json();
                const _currentVersion = localStorage.getItem('idUiVersion');
                setCurrentVersion(_currentVersion);
                checkCountRef.current += 1;
                if (_currentVersion && _currentVersion !== data.version) {
                    if (checkCountRef.current === 1) {
                        // auto reload as they just entered the site
                        localStorage.setItem('idUiVersion', data.version);
                        setTimeout(() => window.location.reload(true), 100);
                    }
                    else {
                        // show the toast message prompting them to save their work and reload
                        localStorage.setItem('idUiVersion', data.version);
                        toast.current.show({
                            severity: 'info',
                            summary: 'A new version of Wallist is available',
                            detail: (
                                <div>
                                    <div className="mt-2 mb-2">
                                        Please save your work before updating
                                    </div>
                                    <button
                                        className="p-link ml-0"
                                        onClick={() => setTimeout(() => window.location.reload(true), 100)}
                                        style={{ marginLeft: '8px', textDecoration: 'underline' }}
                                    >
                                        Click here to reload and update
                                    </button>
                                </div>
                            ),
                            sticky: true
                        });
                    }
                } else if (!_currentVersion) {
                    localStorage.setItem('idUiVersion', data.version);
                }
            } catch (error) {
                console.log('ID UI Version check failed:', error);
            }
        };

        if (TokenService.isAuthenticated()) {
            Mixpanel.identify(TokenService.getUserName());
        }
        checkVersion();
        const interval = setInterval(checkVersion, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <Toast ref={toast} position="top-center" />
            <Routes>
                <Route path="/" exact element={<DefaultPage />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/complete-profile" element={<CompleteProfile />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route
                    path="/account/*"
                    element={
                        <ProtectedUserRoute>
                            <AccountHome />
                        </ProtectedUserRoute>
                    }
                ></Route>
            </Routes>
            <div className="hidden">
                {currentVersion}
            </div>
        </div>
    );
};

export default AppWrapper;
